<div class="te-col-center">



    <h2 *ngIf="errorType == 'UserMismatch'" class="te-col-center" mat-dialog-title>{{'UserIdMisMatchHeader' | translate}}</h2>


    <p *ngIf="errorType == 'UserMismatch'" class="te-form-600 te-alert-danger" mat-dialog-title>
        <span  class="te-row-full">{{'UserIdMisMatchMessage' | translate}}</span>
        <span class="te-row-full">{{ 'UserIdMisMatchMessage2' | translate }}</span>
        
    </p>

    <h2 *ngIf="errorType == 'MFAFailed'" class="te-col-center" mat-dialog-title>Error</h2>


    <p *ngIf="errorType == 'MFAFailed'" class="te-form-600 te-alert-danger" mat-dialog-title>Azure MFA Authentication Failed</p>



</div>